module.exports = "/images/vendor/desiigner-svg/svg/ui/pin.svg?995a28f863db4343448c5fdb83f90f67";